module.exports = __webpack_public_path__ + "img/blockAB5A.e6393024.svg";